module.exports = __webpack_public_path__ + "static/img/font.782bff26.png";